// extracted by mini-css-extract-plugin
export default {"content":"Retroatividade_content__YwnLJ"};